module.exports = __webpack_public_path__ + "assets/img/keyword-search-grid.c4c6627e.svg";